// extracted by mini-css-extract-plugin
export default {"gameInfo":"GameInfoCard_gameInfo__--XxE","additionalInfo":"GameInfoCard_additionalInfo__6yaiT"};